import React from "react";

import {confirmAndDeleteFood, useFoodForms} from "@client/features/foods";
import * as search from "@client/features/search";

import * as router from "@client/router";

import {submitForm} from "@client/site/forms";
import {server} from "@reactivated";

export const UpdateFood = router.UpdateFood.withHooks((props) => {
    return useFoodForms({initial: props.resolved.update_food});
})
    .withTab(
        {
            name: "macros",
            icon: "bullseye",
            title: "Macros",
            hasErrors: (props) => props.basicLayout.hasErrors,
        },
        (props) => <>{props.basicLayout.component}</>,
    )
    .withTab(
        {
            name: "advanced",
            icon: "list",
            title: "Advanced",
            hasErrors: (props) => props.advancedLayout.hasErrors,
        },
        (props) => <>{props.advancedLayout.component}</>,
    )
    .withActions((props) => [
        {
            icon: "remove",
            title: "",
            onClick: () =>
                props.dispatch(confirmAndDeleteFood(props.resolved.update_food)),
        },
        {
            icon: "save",
            title: "Save",
            onClick: async () => {
                const result = await submitForm(
                    server.journal.nutrition.update_food,
                    {...props.form.values, food_id: props.resolved.update_food.id},
                    props.form,
                );
                if (result.type === "success") {
                    void props.dispatch(search.loadSearch({reset: true}));
                    props.notify("Your food was updated");
                    router.push("food_list.index", {});
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Update Food",
        back: "My Foods",
        scene: {kind: "SIMPLE"},
    }));
